import {v4 as uuidv4} from 'uuid';
import {
  GameTimeBaseMessage,
  GameTimeStingers,
  NeptuneStingers,
  SchoolZoneStingers,
} from './OnboardMessageData';

const replaceTeamName = (message: string, teamName: string) => {
  return message.replace(/XXX/g, teamName);
};

export const getSchoolZoneStingerScripts = (partnerName: string) => {
  const schoolZoneStingersMessages = SchoolZoneStingers.map(
    ({name, message}) => ({
      id: uuidv4(),
      name,
      message: replaceTeamName(message, partnerName),
      message_type: 'stinger',
      isSelected: true,
    }),
  );
  return schoolZoneStingersMessages;
};

export const getBaseMessageScripts = (partnerName: string) => {
  const gameTimeMessages = GameTimeBaseMessage.map(({name, message}) => ({
    id: uuidv4(),
    name,
    message: replaceTeamName(message, partnerName),
    message_type: 'dj',
  }));
  return gameTimeMessages;
};

export const getStingersScripts = (partnerName: string) => {
  const gameTimeMessages = GameTimeStingers.map(
    ({name, message, isSelected}) => ({
      id: uuidv4(),
      name,
      message: message.map((msg: string) => replaceTeamName(msg, partnerName)),
      isSelected,
      message_type: 'stinger',
    }),
  );
  return gameTimeMessages;
};

export const getNeptuneStingersScripts = (
  partnerName: string,
  primary: string,
) => {
  let nepStingers:
    | {primary: string; data: {name: string; message: string}[]}
    | undefined;
  nepStingers = NeptuneStingers.find(x => x.primary === primary);
  if (!nepStingers) {
    nepStingers = NeptuneStingers.find(x => x.primary === 'All Other');
  }
  const neptuneStingersMessages = nepStingers?.data.map(({name, message}) => ({
    id: uuidv4(),
    name,
    message: replaceTeamName(message, partnerName),
    message_type: 'stinger',
    isSelected: true,
  }));
  return neptuneStingersMessages;
};
